import { render, staticRenderFns } from "./DTSerial.vue?vue&type=template&id=d7a443c0&scoped=true"
import script from "./DTSerial.vue?vue&type=script&lang=js"
export * from "./DTSerial.vue?vue&type=script&lang=js"
import style0 from "./DTSerial.vue?vue&type=style&index=0&id=d7a443c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a443c0",
  null
  
)

export default component.exports